<app-text-input
  (ngModelChange)="onSearchChange($event)"
  [label]="vm.label"
  [placeHolder]="vm.placeHolder || 'Start typing here...'"
  [ngModel]="searchTerm"
  [ngModelOptions]="{ standalone: true }"
  (onFocus)="showOptions.set(true)"
  name="search-holder"
>
  @if (vm.loading) {
  <app-loading-spinner icon-end [size]="20" />
  } @else {
  <i icon-end class="fa-regular fa-search"></i>
  }
</app-text-input>

<p class="hint mt-4">{{ exampleText() }}</p>

@if (value) {
<section
  class="selected-item flex-col gap-8 mt-16 mb-12"
  *ngIf="showSelectedFault()"
>
  <section class="flex">
    <p class="label">Selected fault</p>

    <button type="button" class="link-text" (click)="writeValue(undefined)">
      Remove
    </button>
  </section>
</section>
} @if (searchTerm.length && vm.showOptions && vm.options.length) {
<p class="body mt-16 mb-12">{{ vm.options.length }} results found</p>

<section #scrollElement class="scroll-container">
  <section class="p-4" [style.height.px]="virtualiser?.getTotalSize()">
    @for (option of vm.options; track option.value; let index = $index) {
    <app-radio-button
      (click)="onOptionClick(option)"
      (ngModelChange)="writeValue($event)"
      [index]="index"
      [includeResetOption]="false"
      [optionValue]="option.value"
      [name]="vm.name"
      [ngModel]="value"
      class="flex mb-8"
      variant="select"
    >
      <p class="label">{{ option.title }}</p>
    </app-radio-button>
    }
  </section>
</section>
}
